import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ModalContent', null, { withChildren: true });
